import React, { Fragment } from "react";
import { Grid } from "@mui/material";
import { DropDown, InputTextField } from "components/UI";
import { ModeAction } from "state/enum";
import { API_SYSTEM_MASTER, COMMON_ENUM, FIRST_PAGE } from "shared/constants";
import { useSelector } from "react-redux";
export default function FilterBar(props) {
  const {
    mode,
    setMode,
    form,
    setForm,
    setRows,
    setOnSearch,
    setMsg: { setMsgAlert, setMsgError },
    dataList: { categoryList, subCategoryList },
    pagination: { pagination, pageNumber, setPagination, setPageNumber },
    rowSelection: { rowSelectionModel, rowModesModel, setRowSelectionModel, setRowModesModel },
  } = props;
  // Form
  const userInfo = useSelector(state => state.auth.user);

  const handleChange = e => {
    setMsgError([]);
    setMsgAlert([]);

    setForm(prev => ({
      ...prev,
      [API_SYSTEM_MASTER.CATEGORY]: e.target.value,
    }));

    setForm({
      userId: userInfo.userName,
      [API_SYSTEM_MASTER.DATA_OWNER]: COMMON_ENUM.C_SM_CTG_TMAP_EM,
      [API_SYSTEM_MASTER.CATEGORY]: e.target.value,
      [API_SYSTEM_MASTER.SUB_CATEGORY]: "",
      [API_SYSTEM_MASTER.CODE]: "",
      [API_SYSTEM_MASTER.VALUE]: "",
      [API_SYSTEM_MASTER.REMARK]: "",
      [API_SYSTEM_MASTER.STATUS]: "",
      [API_SYSTEM_MASTER.STATUS_ID]: "",
      [API_SYSTEM_MASTER.CREATE_BY]: "",
      [API_SYSTEM_MASTER.CREATE_DATE]: "",
      [API_SYSTEM_MASTER.UPDATE_BY]: "",
      [API_SYSTEM_MASTER.UPDATE_DATE]: "",
    });

    setMode(ModeAction.VIEW);
    setOnSearch(false);
    // Reset state table
    setRowSelectionModel([]);
    setRowModesModel({});
    setRows([]);
    setPagination({});
    setPageNumber(FIRST_PAGE);
  };
  return (
    <Fragment>
      <Grid container spacing={1} sx={{ alignItems: "center" }}>
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>*Category: </strong>
          <DropDown
            id="select_category"
            required
            value={form?.category}
            onChange={handleChange}
            autoFocus={true}
            menu={categoryList?.map(val => ({
              key: val?.category,
              value: val?.category,
            }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            defaultValue=""
            placeholder="<Select>"
          />
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>SubCategory: </strong>
          <DropDown
            id="select_sub_category"
            value={form?.subCategory}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                [API_SYSTEM_MASTER.SUB_CATEGORY]: e.target.value,
              }));
            }}
            menu={subCategoryList?.map(val => ({
              key: val?.subCategory,
              value: val?.subCategory,
            }))}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            defaultValue=""
            placeholder="<All>"
          />
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "325px" }}>Code: </strong>
          <InputTextField
            id="input_code"
            style={{ textAlign: "left" }}
            fullWidth
            value={form?.code}
            maxLength={40}
            onChange={e => {
              setForm(prev => ({
                ...prev,
                [API_SYSTEM_MASTER.CODE]: e.target.value?.toUpperCase(),
              }));
            }}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
          />
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </Fragment>
  );
}

// TooLongString123456 (more than 10 characters)
// Invalid@Symbol* (contains invalid character '@')
// Short* (less than 9 characters before '*')
// Space In Between* (contains space in between)
// SpecialCharacter$ (contains special character '$')
